import { render, staticRenderFns } from "./SelectFolderModal.vue?vue&type=template&id=51f5a4b8&scoped=true"
import script from "./SelectFolderModal.vue?vue&type=script&lang=js"
export * from "./SelectFolderModal.vue?vue&type=script&lang=js"
import style0 from "./SelectFolderModal.vue?vue&type=style&index=0&id=51f5a4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5a4b8",
  null
  
)

export default component.exports